import { render, staticRenderFns } from "./HelpCenterDetail.vue?vue&type=template&id=abba0664&scoped=true&"
import script from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
export * from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterDetail.vue?vue&type=style&index=0&id=abba0664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abba0664",
  null
  
)

export default component.exports